import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { DateRangePicker } from 'features/range-date/date-range-picker'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import { useInsuranceDraft } from '../../model/insurance-draft'

const MAX_INSURANCE_PERIOD_DAYS = 365

const CalendarInsurancePage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { draft, setDates } = useInsuranceDraft()

  return (
    <DateRangePicker
      typeCalendar="insurance"
      confirmText={t('insurance.vzr.actions.save')}
      showResetIcon={false}
      dateFormat={DATE_FORMAT_LIST.DATE_MONTH}
      maxRangeDays={MAX_INSURANCE_PERIOD_DAYS}
      showRange
      placeholders={{
        from: t('insurance.vzr.dates.start_placeholder'),
        to: t('insurance.vzr.dates.end_placeholder'),
      }}
      focusDate={draft.startDate || draft.endDate}
      selectedDate={{
        startDate: draft.startDate,
        endDate: draft.endDate,
      }}
      header={
        <HeaderGoBack
          title={t('insurance.vzr.dates.calendar_title')}
          variant="grey"
          isFixed={false}
          onGoBack={() => navigate(-1)}
          buttonWhite
        />
      }
      onChange={({ startDate, endDate }) => {
        if (!startDate || !endDate) {
          return
        }

        setDates(startDate, endDate)
        navigate(RoutingPaths.insurance.application.path())
      }}
    />
  )
}

export default CalendarInsurancePage
